//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ServerAction from "../ServerAction.js";

const SyncServerAction = class SyncServerAction extends ServerAction {
  constructor(stage, sessionId) {
    super("SyncServerAction");
    this.stage = stage;
    this.session_id = sessionId;
  }
};

export default SyncServerAction;
